module.exports = __webpack_public_path__ + "static/media/HCMM207.d49364b5.jpg";